import { render } from "./TabsControl.vue?vue&type=template&id=10ae0140&scoped=true"
import script from "./TabsControl.vue?vue&type=script&lang=js"
export * from "./TabsControl.vue?vue&type=script&lang=js"

import "./TabsControl.vue?vue&type=style&index=0&id=10ae0140&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-10ae0140"]])

export default __exports__